import { DefaultState } from '@src/redux/types'

import { DASHBOARD_TEACHER } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [DASHBOARD_TEACHER]: DefaultState<`${typeof API.DASHBOARD_TEACHER}`, 'get'>
} = () => ({
  [DASHBOARD_TEACHER]: defaultState(),
})
